// Single source of truth for role → default route mapping. Used by:
//   - AuthCallbackPage.tsx (post-OAuth landing)
//   - Page403.tsx (contextual CTA when an authenticated user lands on
//     the access-denied page — bouncing them to /signin would create a
//     loop because /signin's useAuthRedirect would push them right back
//     to /dashboard).
//
// The mapping is deliberately tiny and not extended into a fully
// configurable router policy: V1 has exactly two destinations, /admin
// and /dashboard, and centralising the mapping here is enough to keep
// the OAuth callback and the 403 fallback in lockstep.

export type RoleForRouting = 'buyer' | 'admin' | 'super_admin' | string | null | undefined;

export function getDefaultRouteForRole(role: RoleForRouting): '/admin' | '/dashboard' | '/signin' {
  if (role === 'admin' || role === 'super_admin') return '/admin';
  if (role === 'buyer') return '/dashboard';
  // Unknown / missing role — bounce to signin. Caller should signOut
  // first when an active session sits behind the unknown role to avoid
  // a useAuthRedirect loop.
  return '/signin';
}
